import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from "react-redux";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import store from "./redux/store";
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <Provider store={store}>
    <React.StrictMode>
       <App /> 
    </React.StrictMode>
  </Provider>,
);
reportWebVitals();
